import React, { useContext, useEffect, useState } from 'react';

// react form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { ModalBody } from '../../../components/modal/Modal';

import { useAlert } from '../../../hooks/useAlert';
import { ZakazkyContext } from '../../../services/zakazkyContext';
import { useFazy } from '../../../hooks/useFazy';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

const dateformat = (date) => {
  return date ? dayjs(date) : null;
};

const formatDate = (date) => {
  return date ? date.format('YYYY-MM-DD') : date;
};

const zakazkaSchema = yup.object().shape({
  clientName: yup.string().required('Meno je povinné'),
  phone: yup.string(),
  clientMail: yup.string().email('Email musí mať správny tvar'),
  number: yup.string(),
  year: yup.string(),
});

const ZakazkyForm = ({
  setOpenPicker,
  mapPosition,
  setMapPosition,
  currentZakazka,
  edit,
  setLat,
  setLng,
  lat,
  lng,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(zakazkaSchema) });

  const { success, error: errorAlert, confirm } = useAlert();

  const { addZakazka, editZakazka } = useContext(ZakazkyContext);

  const { fazy, stavy, years } = useFazy();

  const [endDate, setEndDate] = useState(null);

  const onSubmit = async (data) => {
    let newData = { ...data, lat: lat?.toString(), lng: lng?.toString() };
    const date = formatDate(endDate);
    newData = { ...newData, dateEnd: date };

    if (edit) {
      editZakazka(currentZakazka?.id, newData);
    } else {
      addZakazka(newData);
    }
  };

  useEffect(() => {
    if (edit) {
      currentZakazka?.dateEnd && setEndDate(dateformat(currentZakazka?.dateEnd));
    }
  }, [currentZakazka]);

  return (
    <ModalBody>
      <Typography variant="h6">Klient</Typography>
      <TextField
        id="menoZakaznika"
        label="Meno zákazníka"
        variant="outlined"
        defaultValue={currentZakazka?.clientName}
        error={errors.clientName}
        helperText={errors.clientName?.message}
        {...register('clientName')}
      />
      <TextField
        id="tel"
        label="Telefonický kontakt"
        variant="outlined"
        defaultValue={currentZakazka?.phone}
        error={errors.phone}
        helperText={errors.phone?.message}
        {...register('phone')}
      />
      <TextField
        id="mail"
        label="E-mail"
        variant="outlined"
        defaultValue={currentZakazka?.clientMail}
        error={errors.clientMail}
        helperText={errors.clientMail?.message}
        {...register('clientMail')}
      />
      <Typography variant="h6">Informácie</Typography>
      <TextField
        id="number"
        label="Číslo stavby"
        variant="outlined"
        defaultValue={currentZakazka?.number}
        error={errors.number}
        helperText={errors.number?.message}
        {...register('number')}
      />
      <Typography variant="h6">GPS</Typography>
      <TextField
        id="district"
        label="Okres"
        variant="outlined"
        defaultValue={currentZakazka?.district}
        error={errors.district}
        helperText={errors.district?.message}
        {...register('district')}
      />
      <TextField
        id="place"
        label="Miesto stavby"
        variant="outlined"
        defaultValue={currentZakazka?.place}
        error={errors.place}
        helperText={errors.place?.message}
        {...register('place')}
      />
      <TextField
        id="lat"
        label="Latitude"
        variant="outlined"
        defaultValue={currentZakazka?.lat}
        {...register('lat')}
        InputLabelProps={{
          shrink: true,
        }}
        value={lat}
        onChange={(e) => setLat(e.target.value)}
      />
      <TextField
        id="lng"
        label="Longitude"
        variant="outlined"
        defaultValue={currentZakazka?.lng}
        value={lng}
        {...register('lng')}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(e) => setLng(e.target.value)}
      />
      <Button
        variant="outlined"
        onClick={() => {
          setOpenPicker(true);
        }}
      >
        Zvoliť na mape
      </Button>
      <FormControl fullWidth sx={{ marginTop: 1 }}>
        <InputLabel id="typFotovoltiky">Fáza realizácie</InputLabel>

        <Select
          label="Fáza realizácie"
          labelId="faza"
          defaultValue={currentZakazka ? currentZakazka?.faza : ''}
          {...register('faza')}
        >
          {fazy.map((faza) => (
            <MenuItem value={faza} key={faza}>
              {faza}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth sx={{ marginTop: 1 }}>
        <InputLabel id="typFotovoltiky">Rok realizácie</InputLabel>

        <Select
          label="Rok realizácie"
          labelId="year"
          defaultValue={currentZakazka ? currentZakazka?.year : ''}
          {...register('year')}
        >
          {years.map((year) => (
            <MenuItem value={year} key={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {/*<FormControl fullWidth sx={{ marginBottom: 2 }}>
        <InputLabel id="typFotovoltiky">Stav stavby</InputLabel>

        <Select
          label="Stav stavby"
          labelId="faza"
          defaultValue={currentZakazka ? currentZakazka?.stav : ''}
          {...register('stav')}
        >
          {stavy.map((stav) => (
            <MenuItem value={stav} key={stav}>
              {stav}
            </MenuItem>
          ))}
        </Select>
          </FormControl>*/}
      {/*<DatePicker label="Dátum ukončenia" value={endDate} onChange={(e) => setEndDate(e)} format="DD/MM/YYYY" />*/}
      <Button
        sx={{
          backgroundColor: '#7fae04',
          color: 'white',
          borderColor: '#7fae04',
          ':hover': {
            backgroundColor: '#7fae04',
            color: 'white',
            opacity: '0.9',
            borderColor: '#7fae04',
          },
        }}
        variant="outlined"
        onClick={handleSubmit(onSubmit)}
      >
        {edit ? 'Upraviť' : 'Vytvoriť'}
      </Button>
    </ModalBody>
  );
};

export default ZakazkyForm;
